import EventPost from 'flarum/forum/components/EventPost';
/**
 * System post: "admin assigned staff and mod." / "admin unassigned mod."
 */
export default class TicketAssignedPost extends EventPost {
  change() {
    const content = this.attrs.post.content();

    // Posts from before multiple assignees: [old, new].
    if (Array.isArray(content)) {
      const [from, to] = content;
      return {
        added: to ? [to] : [],
        removed: from ? [from] : []
      };
    }
    return content;
  }
  icon() {
    return 'fas fa-user-tag';
  }
  descriptionKey() {
    const {
      added,
      removed
    } = this.change();
    if (added.length && removed.length) return 'soup-97-support.forum.post_stream.assigned_and_unassigned_text';
    if (added.length) return 'soup-97-support.forum.post_stream.assigned_text';
    return 'soup-97-support.forum.post_stream.unassigned_text';
  }
  descriptionData() {
    const {
      added,
      removed
    } = this.change();
    const names = users => m("strong", null, users.map(user => user.displayName).join(', '));
    return {
      added: names(added),
      removed: names(removed)
    };
  }
}
flarum.reg.add('soup-97-support', 'forum/components/posts/TicketAssignedPost', TicketAssignedPost);